import { RegardMark } from '@rgrd/component-library'
import { Link, useMatch } from 'react-router'

import { getCustomerPath } from '~/shell/app/paths'

import { ActiveAppNav } from './ActiveAppNav'
import styles from './AppHeader.module.css'
import { CustomerCluster } from './CustomerCluster'
import { ProductSwitcher } from './ProductSwitcher'

/**
 * The Scout application header.
 *
 * Ported from arc's `AppHeader`. The wordmark links to the customer root rather than
 * `/`, so "home" keeps the session's customer instead of bouncing through the default
 * one. The customer is read by matching the location rather than with `useParams`,
 * because the header renders in the layout above the routed page. Should it ever
 * render outside a customer-scoped route, `/` still resolves via the root redirect.
 *
 * The primary nav is `ActiveAppNav`, which resolves the active app's own nav: the items come from the
 * mounted app's endpoints, so the app supplies them and the header decides only where they sit (see
 * `shared/appContract`).
 */
export const AppHeader = () => {
  const customerMatch = useMatch({ end: false, path: '/c/:customer' })
  const customer = customerMatch?.params.customer

  return (
    <header className={styles.header}>
      <div className={styles.left}>
        <Link
          to={customer === undefined ? '/' : getCustomerPath(customer)}
          className={styles.wordmark}
        >
          <RegardMark size={26} />
          <span className={styles.wordmarkText}>Population Health</span>
        </Link>
        <ProductSwitcher />
        <ActiveAppNav />
      </div>
      <CustomerCluster />
    </header>
  )
}
